module.exports = __webpack_public_path__ + "img/Standard-icon.b3a55c28.png";